export default {
  cashAccounts: (state) => {
    return state.cashAccounts;
  },
  cashAccount: (state) => {
    return state.cashAccount;
  },
  cashAccountId: (state) => {
    return state.cashAccountId;
  },
  cashAccountCode: (state) => {
    return state.cashAccountCode;
  },
  cashAccountVoucher: (state) => {
    return state.cashAccountVoucher;
  },

  bankAccounts: (state) => {
    return state.bankAccounts;
  },
  bankAccount: (state) => {
    return state.bankAccount;
  },
  bankAccountId: (state) => {
    return state.bankAccountId;
  },
  bankAccountCode: (state) => {
    return state.bankAccountCode;
  },
  bankAccountVoucher: (state) => {
    return state.bankAccountVoucher;
  },

  chequeStatuses: (state) => {
    return state.chequeStatuses;
  },

  chequeBatch: (state) => {
    return state.chequeBatch;
  },
  chequeBatchCode: (state) => {
    return state.chequeBatchCode;
  },

  chequeBatchDetail: (state) => {
    return state.chequeBatchDetail;
  },

  chequeBatchDetailByNumber: (state) => {
    return state.chequeBatchDetailByNumber;
  },
  chequeBatchDetailByNumberOptions: (state) => {
    const chequeBatchDetailByNumberOptions = [];
    state.chequeBatchDetailByNumber.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
      };
      chequeBatchDetailByNumberOptions.push(pushItem);
    }
    return chequeBatchDetailByNumberOptions;
  },

  paymentChequeDetailByNumber: (state) => {
    return state.paymentChequeDetailByNumber;
  },
  paymentChequeDetailByNumberOptions: (state) => {
    const paymentChequeDetailByNumberOptions = [];
    state.paymentChequeDetailByNumber.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code,
        bankCashAccountId: item.bankCashAccountId,
      };
      paymentChequeDetailByNumberOptions.push(pushItem);
    }
    return paymentChequeDetailByNumberOptions;
  },

  receiveCashes: (state) => {
    return state.receiveCashes;
  },
  receiveCash: (state) => {
    return state.receiveCash;
  },
  receiveCashId: (state) => {
    return state.receiveCashId;
  },
  receiveCashVoucherId: (state) => {
    return state.receiveCashVoucherId;
  },

  receiveCashCode: (state) => {
    return state.receiveCashCode;
  },

  receiveCashNavigation: (state) => {
    return state.receiveCashNavigation;
  },

  receiveCashCheckDelete: (state) => {
    return state.receiveCashCheckDelete;
  },

  receiveCashVoucher: (state) => {
    return state.receiveCashVoucher;
  },
  receiveVoucherNumber: (state) => {
    return state.receiveVoucherNumber;
  },
  receiveVoucherId: (state) => {
    return state.receiveVoucherId;
  },

  paymentCashes: (state) => {
    return state.paymentCashes;
  },
  paymentCash: (state) => {
    return state.paymentCash;
  },
  paymentCashId: (state) => {
    return state.paymentCashId;
  },

  paymentCashCode: (state) => {
    return state.paymentCashCode;
  },

  paymentCashNavigation: (state) => {
    return state.paymentCashNavigation;
  },

  paymentCashVoucher: (state) => {
    return state.paymentCashVoucher;
  },

  paymentCashCheckDelete: (state) => {
    return state.paymentCashCheckDelete;
  },
  paymentVoucherNumber: (state) => {
    return state.paymentVoucherNumber;
  },
  paymentVoucherId: (state) => {
    return state.paymentVoucherId;
  },

  requestPayments: (state) => {
    return state.requestPayments;
  },
  requestPayment: (state) => {
    return state.requestPayment;
  },
  requestPaymentCode: (state) => {
    return state.requestPaymentCode;
  },
  requestPaymentNavigation: (state) => {
    return state.requestPaymentNavigation;
  },

  receiveCheques: (state) => {
    return state.receiveCheques;
  },
  receiveChequeCreateCheck: (state) => {
    return state.receiveChequeCreateCheck;
  },
  receiveCheque: (state) => {
    return state.receiveCheque;
  },

  receiveChequeCode: (state) => {
    return state.receiveChequeCode;
  },

  receiveChequeId: (state) => {
    return state.receiveChequeId;
  },

  receiveChequeData: (state) => {
    return state.receiveChequeData;
  },

  receiveChequeBackNumber: (state) => {
    return state.receiveChequeBackNumber;
  },

  receiveChequeBankTransfer: (state) => {
    return state.receiveChequeBankTransfer;
  },

  transactionInfo: (state) => {
    return state.transactionInfo;
  },

  receiveChequeSampleExcel: (state) => {
    return state.receiveChequeSampleExcel;
  },

  receiveChequeCartable: (state) => {
    return state.receiveChequeCartable;
  },

  receiveChequeVoucher: (state) => {
    return state.receiveChequeVoucher;
  },

  receiveChequeNavigation: (state) => {
    return state.receiveChequeNavigation;
  },

  bankTransfers: (state) => {
    return state.bankTransfers;
  },
  bankTransferIds: (state) => {
    return state.bankTransferIds;
  },

  assignmentPersons: (state) => {
    return state.assignmentPersons;
  },
  assignmentPersonIds: (state) => {
    return state.assignmentPersonIds;
  },

  settlements: (state) => {
    return state.settlements;
  },

  returnTransferreds: (state) => {
    return state.returnTransferreds;
  },

  cancellationReceivables: (state) => {
    return state.cancellationReceivables;
  },

  returnReceivables: (state) => {
    return state.returnReceivables;
  },

  returnReceivableIds: (state) => {
    return state.returnReceivableIds;
  },

  returnGuarantees: (state) => {
    return state.returnGuarantees;
  },

  returnAssignments: (state) => {
    return state.returnAssignments;
  },
  returnAssignmentIds: (state) => {
    return state.returnAssignmentIds;
  },

  requestPaymentConfirm: (state) => {
    return state.requestPaymentConfirm;
  },

  receiveChequeTurns: (state) => {
    return state.receiveChequeTurns;
  },
  receiveChequeTurn: (state) => {
    return state.receiveChequeTurn;
  },

  paymentCheques: (state) => {
    return state.paymentCheques;
  },
  paymentCheque: (state) => {
    return state.paymentCheque;
  },
  paymentChequeId: (state) => {
    return state.paymentChequeId;
  },
  paymentChequeData: (state) => {
    return state.paymentChequeData;
  },

  paymentChequeCode: (state) => {
    return state.paymentChequeCode;
  },

  paymentChequeTurns: (state) => {
    return state.paymentChequeTurns;
  },
  paymentChequeTurn: (state) => {
    return state.paymentChequeTurn;
  },

  paymentChequeNavigation: (state) => {
    return state.paymentChequeNavigation;
  },

  paymentChequeCartable: (state) => {
    return state.paymentChequeCartable;
  },

  paymentChequeCheckDelete: (state) => {
    return state.paymentChequeCheckDelete;
  },

  paymentChequeSampleExcel: (state) => {
    return state.paymentChequeSampleExcel;
  },

  paymentChequeVoucher: (state) => {
    return state.paymentChequeVoucher;
  },

  passPayDocs: (state) => {
    return state.passPayDocs;
  },

  cancelPayableDocs: (state) => {
    return state.cancelPayableDocs;
  },

  returnGuaranteeDocs: (state) => {
    return state.returnGuaranteeDocs;
  },

  receiveChequeReport: (state) => {
    return state.receiveChequeReport;
  },

  dueReceiveChequeReport: (state) => {
    return state.dueReceiveChequeReport;
  },

  monthlyComparisonReceiveChequeReport: (state) => {
    return state.monthlyComparisonReceiveChequeReport;
  },

  receiveCashAndCahPaymentReport: (state) => {
    return state.receiveCashAndCahPaymentReport;
  },

  cashAndChequeOperationDetailReport: (state) => {
    return state.cashAndChequeOperationDetailReport;
  },

  monthlyComparisonReceiveAndPaymentCashReport: (state) => {
    return state.monthlyComparisonReceiveAndPaymentCashReport;
  },

  historyReceiveChequeReport: (state) => {
    return state.historyReceiveChequeReport;
  },
  summaryReceiveChequeReport: (state) => {
    return state.summaryReceiveChequeReport;
  },

  paymentChequeReport: (state) => {
    return state.paymentChequeReport;
  },
  historyPaymentChequeReport: (state) => {
    return state.historyPaymentChequeReport;
  },
  monthlyComparisonPaymentChequeReport: (state) => {
    return state.monthlyComparisonPaymentChequeReport;
  },
  paymentChequeToPersonReport: (state) => {
    return state.paymentChequeToPersonReport;
  },
  paymentChequeToAccountInfoReport: (state) => {
    return state.paymentChequeToAccountInfoReport;
  },
  paymentChequeTurnReport: (state) => {
    return state.paymentChequeTurnReport;
  },
  summaryPaymentChequeReport: (state) => {
    return state.summaryPaymentChequeReport;
  },
  overduePaymentChequeReport: (state) => {
    return state.overduePaymentChequeReport;
  },

  circulationVoucherReport: (state) => {
    return state.circulationVoucherReport;
  },

  cashFlowReport: (state) => {
    return state.cashFlowReport;
  },
  cashFlowTableTwoReport: (state) => {
    return state.cashFlowTableTwoReport;
  },

  accountInventoryReport: (state) => {
    return state.accountInventoryReport;
  },
  summaryPaymentChequeTab: (state) => {
    return state.summaryPaymentChequeTab;
  },
  summaryReceiveChequeTab: (state) => {
    return state.summaryReceiveChequeTab;
  },
  summaryReceiveAndPaymentCash: (state) => {
    return state.summaryReceiveAndPaymentCash;
  },

  receiveAndPayment: (state) => {
    return state.receiveAndPayment;
  },
  receiveAndPaymentById: (state) => {
    return state.receiveAndPaymentById;
  },
  receiveAndPaymentMaxCode: (state) => {
    return state.receiveAndPaymentMaxCode;
  },

  issueTrackingTypes: (state) => {
    return state.issueTrackingTypes;
  },

  receiptRecevied: (state) => {
    return state.receiptRecevied;
  },
  receiptReceviedById: (state) => {
    return state.receiptReceviedById;
  },
  receiptReceviedMaxCode: (state) => {
    return state.receiptReceviedMaxCode;
  },
  exportReceivedPaper: (state) => {
    return state.exportReceivedPaper;
  },
  receiptReceviedNavigation: (state) => {
    return state.receiptReceviedNavigation;
  },

  paymentPaper: (state) => {
    return state.paymentPaper;
  },
  paymentPaperById: (state) => {
    return state.paymentPaperById;
  },
  paymentPaperMaxCode: (state) => {
    return state.paymentPaperMaxCode;
  },
  paymentPaperNavigation: (state) => {
    return state.paymentPaperNavigation;
  },
  exportPaymentPaper: (state) => {
    return state.exportPaymentPaper;
  },

  paymentChequeManagementCartable: (state) => {
    return state.paymentChequeManagementCartable;
  },
  requestPaymentManagementCartable: (state) => {
    return state.requestPaymentManagementCartable;
  },
  receiveChequeManagementCartable: (state) => {
    return state.receiveChequeManagementCartable;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },

  pbankAttachs: (state) => {
    return state.pbankAttachs;
  },

  dashboardSixPieCharts: (state) => {
    return state.dashboardSixPieCharts;
  },
  firstLineChart: (state) => {
    return state.firstLineChart;
  },
  secondLineChart: (state) => {
    return state.secondLineChart;
  },
  thirdLineChart: (state) => {
    return state.thirdLineChart;
  },
  fourthLineChart: (state) => {
    return state.fourthLineChart;
  },
  fifthLineChart: (state) => {
    return state.fifthLineChart;
  },
  sixthLineChart: (state) => {
    return state.sixthLineChart;
  },
  printLink: (state) => {
    return state.printLink;
  },

  interBankTransfer: (state) => {
    return state.interBankTransfer;
  },
  interBankTransferItem: (state) => {
    return state.interBankTransferItem;
  },
  interBankTransferNavigation: (state) => {
    return state.interBankTransferNavigation;
  },
  bankTransferMaxCode: (state) => {
    return state.bankTransferMaxCode;
  },
  interBankTransferId: (state) => {
    return state.interBankTransferId;
  },
  interBankTransferVoucher: (state) => {
    return state.interBankTransferVoucher;
  },
  bankTransferCheckDelete: (state) => {
    return state.bankTransferCheckDelete;
  },
  bankTransferVoucherNumber: (state) => {
    return state.bankTransferVoucherNumber;
  },
  bankTransferVoucherId: (state) => {
    return state.bankTransferVoucherId;
  },
};
